import { render, staticRenderFns } from "./check-customer.vue?vue&type=template&id=2ef4dc53&"
import script from "./check-customer.vue?vue&type=script&lang=js&"
export * from "./check-customer.vue?vue&type=script&lang=js&"
import style0 from "./check-customer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports